import { notification } from "antd";
import { useCallback } from "react";
import { SubmitHandler } from "react-hook-form";
import { SchemaFormTheme } from "../../../../components/forms/FormTheme";
import {
  useCreateThemeMutation,
  useDeleteThemeMutation,
  useUpdateThemeMutation,
} from "../../apiSlice";
import { getErrorMessage } from "../../../../utils/errors/errors";

type FetchThemes = () => void;

export const useCrudTheme = (
  themeId: number,
  fetchThemes: FetchThemes,
  onHideModal: () => void,
) => {
  const [lazyCreateTheme, { isLoading: isCreating }] = useCreateThemeMutation();
  const [lazyUpdateTheme, { isLoading: isUpdating }] = useUpdateThemeMutation();
  const [lazyDeleteTheme, { isLoading: isDeleting }] = useDeleteThemeMutation();

  const createTheme: SubmitHandler<SchemaFormTheme> = useCallback(
    async (values) => {
      try {
        await lazyCreateTheme(values).unwrap();
        notification.success({ message: "ThÃ¨me crÃ©Ã© avec succÃ¨s." });
        onHideModal();
        fetchThemes();
      } catch (e) {
        notification.error({ message: "Erreur", description: getErrorMessage(e) });
      }
    },
    [lazyCreateTheme, fetchThemes, onHideModal],
  );

  const updateTheme: SubmitHandler<SchemaFormTheme> = useCallback(
    async (values) => {
      try {
        await lazyUpdateTheme({ themeId, values }).unwrap();
        notification.success({ message: "ThÃ¨me modifiÃ© avec succÃ¨s." });
        onHideModal();
        fetchThemes();
      } catch (e) {
        notification.error({ message: "Erreur", description: getErrorMessage(e) });
      }
    },
    [themeId, lazyUpdateTheme, fetchThemes, onHideModal],
  );

  const onDelete = useCallback(
    async (id: number) => {
      try {
        await lazyDeleteTheme(id).unwrap();
        notification.success({ message: "ThÃ¨me supprimÃ© avec succÃ¨s." });
        fetchThemes();
      } catch (e) {
        notification.error({ message: "Erreur", description: getErrorMessage(e) });
      }
    },
    [lazyDeleteTheme, fetchThemes],
  );

  return { createTheme, isCreating, updateTheme, isUpdating, onDelete, isDeleting };
};
